
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-category/[...slug]",
      function () {
        return require("private-next-pages/product-category/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-category/[...slug]"])
      });
    }
  